module.exports = __webpack_public_path__ + "assets/0e926a64cc18f1f46de901afdf9cf1e1.svg";